var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Tel\\xE9fono",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#08786F",
    strokeWidth: 5.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M50.2 41.9v5.6a4.4 4.4 0 0 1-4.78 4.38 43.3 43.3 0 0 1-18.86-6.7 42.44 42.44 0 0 1-13.1-13.1A43.3 43.3 0 0 1 6.75 13.1a4.4 4.4 0 0 1 4.36-4.78h5.6a4.4 4.4 0 0 1 4.38 3.78c.28 2.1.76 4.14 1.45 6.06a4.4 4.4 0 0 1-1 4.63l-2.7 2.7a35.05 35.05 0 0 0 13.1 13.1l2.7-2.7a4.4 4.4 0 0 1 4.63-1c1.92.69 3.96 1.17 6.06 1.45a4.4 4.4 0 0 1 3.87 4.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4c79894d7c2c870dd9f9b03dce0b138.svg";
export { ForwardRef as ReactComponent };